import Location from 'app-location'

export const AuthEndpoint = new Location('/auth/sign_in')
export const AuthSignUpEndpoint = new Location('/auth')
